import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type InventoryPeriodConfigRecord = {
  id: string;
  periodType: string;
  fiscalYearStartMonth: number | null;
  allowStraddleCompletion: boolean;
  straddleWindowPeriods: number;
  requireStraddleApproval: boolean;
};

export const inventoryPeriodConfigQueryAtom = createQueryAtomFactory(
  'inventory.inventoryPeriodConfigByOrganization',
  () => ({
    inventoryPeriodConfigByOrganization: {
      id: true,
      periodType: true,
      fiscalYearStartMonth: true,
      allowStraddleCompletion: true,
      straddleWindowPeriods: true,
      requireStraddleApproval: true,
    },
  }),
  {
    select: (data): InventoryPeriodConfigRecord | null =>
      data?.inventoryPeriodConfigByOrganization ?? null,
  },
);
